export default __webpack_public_path__ + "static/media/mt5.ea75cbc9.png";